export { childrenExist } from '@fluentui/react-bindings';

export { rtlTextContainer } from './rtlTextContainer';
export { stringLiteralsArray } from './stringLiteralsArray';
export { getOrGenerateIdFromShorthand } from './getOrGenerateIdFromShorthand';

export * from './factories';
export { mergeProviderContexts } from './mergeProviderContexts';

export * from './renderComponent';
export { renderComponent } from './renderComponent';

export { htmlImageProps, htmlInputAttrs, htmlInputEvents, htmlInputProps, partitionHTMLProps } from './htmlPropsUtils';

export { isBrowser } from './isBrowser';
export { doesNodeContainClick } from './doesNodeContainClick';

export { pxToRem } from './fontSizeUtility';
export { createComponent } from './createComponent';
export { getKindProp } from './getKindProp';
export { shouldPreventDefaultOnKeyDown } from './shouldPreventDefaultOnKeyDown';
export * from './whatInput';

export { screenReaderContainerStyles } from './accessibility/Styles/accessibilityStyles';
export * from './commonPropTypes';
